import React from 'react';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const LoanAmountEditor = ({
    value,
    onChange,
    label,
    error,
}) => {
    const handleChange = (content, delta, source, editor) => {
        const quillDelta = editor.getContents();
        onChange(JSON.stringify(quillDelta));
    };
    const formats = [
        "list",
        "indent",
        "bold",
        "italic",
        "underline",
    ];

    const modules = {
        toolbar: [
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["bold", "italic", "underline"],
        ],
    };


    // const handleChange = (content, delta, source, editor) => {
    //   const quillDelta = editor.getContents();
    //   onChange(JSON.stringify(quillDelta));
    // };


    return (
        <div className='su_field_block su_field_full'>
            {label && <label className="su_field_label">{label}</label>}
            <div className="su_quill_wrapper">
                <ReactQuill
                    theme="snow"
                    value={value}
                    onChange={handleChange}
                    modules={modules}
                    formats={formats}
                />
            </div>
            {error && <div className="su_error">{error}</div>}
        </div>
    );
};

export default LoanAmountEditor;
